
import { useSelector  } from 'react-redux';

import { getDatawin } from '../reducers'
import { getFetchAttributeVisibility } from '../reducers/datawin'

export default function useDatawinFetchAttributeVisibility(dataModelItemId) {
    const datawin = useSelector(state => getDatawin(state.data));
    return getFetchAttributeVisibility(datawin, dataModelItemId);
}
